/**
 * La classe de l'enfant, telle que le récapitulatif et la fiche la disent :
 * choisie, signalée à l'équipe, ou encore à indiquer (en orange, jamais en
 * rouge — elle ne bloque que les journées pédagogiques et le parascolaire).
 */

import type { ResumeClasse } from '../../../lib/classes/regles';

const LigneClasse = ({ resume }: { resume: ResumeClasse }) => {
  if (resume.etat === 'a-indiquer') return <span className="text-amber-600">{resume.texte}</span>;
  if (resume.etat === 'signalee') return <span className="text-green-700">{resume.texte}</span>;
  return <>{resume.texte}</>;
};

export default LigneClasse;
